export class Track {
  name: string;
  url: string;
  artist: string;
  cover: string;
}
